import { useEffect } from 'react';

// Lightweight per-route SEO for the SPA: updates the document <title> and the
// description / Open Graph / Twitter meta tags when a route mounts. (JS-rendering
// crawlers pick these up; for full SSR you'd prerender, but this gives every
// route a distinct, accurate title & description.)
function setAttr(selector, value) {
  if (value == null) return;
  const el = document.querySelector(selector);
  if (el) el.setAttribute('content', value);
}

export function useSeo(title, description) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setAttr('meta[property="og:title"]', title);
      setAttr('meta[name="twitter:title"]', title);
    }
    if (description) {
      setAttr('meta[name="description"]', description);
      setAttr('meta[property="og:description"]', description);
      setAttr('meta[name="twitter:description"]', description);
    }
  }, [title, description]);
}
